const events = {
  cytogenetics: [
    "complex",
    "+8",
    "+11",
    "+13",
    "+21",
    "+22",
    "-3",
    "-5",
    "-7",
    "-9",
    "-12",
    "-13",
    "-16",
    "-17",
    "-18",
    "-20",
    "-Y",
    "t(1_12)",
    "t(1_14)",
    "t(1_16)",
    "t(1_17)",
    "t(1_19)",
    "t(1_3)",
    "t(1_4)",
    "t(1_5)",
    "t(1_6)",
    "t(2_17)",
    "t(2_3)",
    "t(2_5)",
    "t(2_7)",
    "t(2_9)",
    "t(3_16)",
    "t(3_21)",
    "t(3_5)",
    "t(3_7)",
    "t(3_9)",
    "t(4_12)",
    "t(4_21)",
    "t(4_9)",
    "t(5_12)",
    "t(5_17)",
    "t(5_9)",
    "t(6_9)",
    "t(7_16)",
    "t(7_17)",
    "t(7_8)",
    "t(8_10)",
    "t(8_13)",
    "t(8_16)",
    "t(8_17)",
    "t(8_21)",
    "t(9_11)",
    "t(9_13)",
    "t(9_17)",
    "t(9_22)",
    "t(10_21)",
    "t(12_13)",
    "t(12_17)",
    "t(12_22)",
    "t(13_19)",
    "t(15_16)",
    "t(15_17)",
    "t(16_17)",
    "t(16_21)",
    "t(17_19)",
    "t(17_21)",
    "t(v_11)",
    "inv(3)",
    "inv(16)",
    "others_transloc"
  ],
  genes: [
    "ASXL1",
    "ASXL2",
    "ASXL3",
    "ATRX",
    "BAGE3",
    "BCOR",
    "BRAF",
    "CBFB",
    "CBL",
    "CDKN2A",
    "CEBPA_bi",
    "CEBPA_mono",
    "CNTN5",
    "CREBBP",
    "CSF1R",
    "CSF3R",
    "CTCF",
    "CUL2",
    "CUX1",
    "DNMT3A",
    "EED",
    "ETV6",
    "EZH2",
    "FBXW7",
    "FLT3_TKD",
    "FLT3_other",
    "GATA1",
    "GATA2",
    "GNAS",
    "GNB1",
    "IDH1",
    "IDH2_p.R140",
    "IDH2_p.R172",
    "ITD",
    "JAK2",
    "JAK3",
    "KANSL1",
    "KDM6A",
    "KIT",
    "KMT2C",
    "KMT2D",
    "KMT2E",
    "KRAS",
    "LUC7L2",
    "MED12",
    "MLL",
    "MPL",
    "MYC",
    "NF1",
    "NFE2",
    "NOTCH1",
    "NPM1",
    "NRAS_other",
    "NRAS_p.G12_13",
    "NRAS_p.Q61_62",
    "PDS5B",
    "PHF6",
    "PPFIA2",
    "PRPF8",
    "PTEN",
    "PTPN11",
    "PTPRF",
    "PTPRT",
    "RAD21",
    "RIT1",
    "RUNX1",
    "S100B",
    "SETBP1",
    "SF1",
    "SF3B1",
    "SMC1A",
    "SMC3",
    "SMG1",
    "SPP1",
    "SRSF2",
    "STAG2",
    "STAT5B",
    "SUZ12",
    "TET2",
    "TP53",
    "U2AF1_p.Q157",
    "U2AF1_p.S34",
    "WT1",
    "ZRSR2"
  ],
  components: [
    "principal_component_CEBPA_bi",
    "principal_component_DNMT3A_IDH1_2",
    "principal_component_NPM1",
    "principal_component_TP53_complex",
    "principal_component_Trisomies",
    "principal_component_WT1",
    "principal_component_inv(16)",
    "principal_component_inv(3)",
    "principal_component_mNOS",
    "principal_component_no_events",
    "principal_component_sAML1",
    "principal_component_sAML2",
    "principal_component_t(11)",
    "principal_component_t(15_17)",
    "principal_component_t(6_9)",
    "principal_component_t(8_21)"
  ]
};

export default events;
